import { useEffect, useState } from "react";
import OpticksButtonLink from "@/components/ui/OpticksButtonLink/OpticksButtonLink";
import { getPaymentsUrl } from "@/services/api/PaymentsRepository";
import OpticksLogo from "@/components/ui/OpticksLogos/OpticksLogo";

const AccountInactive = () => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    getPaymentsUrl()
      .then((res) => {
        const { data } = res || {};
        if (res && "url" in data) setUrl(data.url);
      })
      .catch((error) => {
        console.error("axios error", error);
        return error;
      });
  }, []);

  return (
    <>
      <OpticksLogo />
      <h2>Your Account is Inactive</h2>

      <p>
        Access to your account has been blocked in line with our Terms &amp;
        Conditions.
      </p>
      <p>
        Please, update the pending payments in order to regain access to your
        Opticks account.
      </p>

      <OpticksButtonLink
        href={url}
        label="Reactivate access"
      />
    </>
  );
};

export default AccountInactive;
